import MojitoCore from 'mojito/core';
import Image from 'presentation/components/image/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';

const classUtils = MojitoCore.Base.classUtils;

const CountryIcon = props => {
    const { countryCode, countryName, mojitoTools } = props;
    const { config, stringResolver } = mojitoTools;
    const alt = countryName
        ? stringResolver.resolveAndFormatString(`$GENERIC.FLAG_OF`, countryName)
        : '';

    return (
        <FlexPane
            config={config.container}
            class={classUtils.classNames('ta-CountryIcon', props.class)}
        >
            <Image
                config={config.icon}
                src={config.countryIcons[countryCode]}
                alt={alt}
                class="ta-CountryIconImage"
            />
        </FlexPane>
    );
};

export default CountryIcon;
